const DataType = {
    UPDATE_DATA_STATE: "UPDATE_DATA_STATE",

}

export default DataType;